import { Button, Grid, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Loader } from "@common/Loader/Loader";
import { IFetchState } from "itsf-ui-common";

interface IParams {
    callState: IFetchState;
    label: string;
    name?: string;
    type: string;
    validate?(value?: string): undefined | string;
    goToInitialStep?(): void;
    handleFormSubmit(value: string): void;
}

export const ForgotEmailForm = (props: IParams) => {
    const { label, type, handleFormSubmit, goToInitialStep, validate, name, callState } = props;

    const { handleSubmit, errors, register } = useForm<{ form: string }>({ defaultValues: { form: "" } });
    const { t } = useTranslation(["forgotEmail", "common", "validation"]);

    const handleBeforeFormSubmit = handleSubmit((formData) => {
        handleFormSubmit(formData.form);
    });

    return (
        <form onSubmit={handleBeforeFormSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        disabled={callState.isLoading}
                        error={Boolean(errors.form)}
                        fullWidth
                        helperText={errors.form?.message}
                        id={name}
                        inputRef={register({
                            required: t("validation:required"),
                            validate: validate ? validate : undefined,
                        })}
                        label={label}
                        margin="dense"
                        name="form"
                        type={type}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Grid container justifyContent="center" spacing={2}>
                        {callState.isLoading && <Loader size={40} />}
                        {goToInitialStep && !callState.isLoading && (
                            <Grid item xs={12}>
                                <Button color="secondary" fullWidth variant="outlined" onClick={goToInitialStep}>
                                    {t("forgotEmail:back")}
                                </Button>
                            </Grid>
                        )}
                        {!callState.isLoading && (
                            <Grid item xs={12}>
                                <Button color="secondary" fullWidth type="submit" variant="contained">
                                    {t("common:continue")}
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </Grid>

                {callState.error && (
                    <Typography color="error">{callState.error.errorMessage || t("common:genericError")}</Typography>
                )}
            </Grid>
        </form>
    );
};
